<template>
    <div class="card mb-3">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <div class="row">
                <div class="col-md-3">
                    <label><label style="color: red; height: 2px;" >*</label>
                        تاریخ</label>
                    <select required class="form-control" v-model="year">
                        <option value="1402">1402</option>
                        <option value="1401">1401</option>
                        <option value="1400">1400</option>
                        <option value="1399">1399</option>
                        <option value="1398">1398</option>
                        <option value="1397">1397</option>
                    </select>
                </div>
                <div class="col-md-3">
                    <label><label style="color: red; height: 2px;" >*</label>
                        ماه</label>
                    <select required class="form-control" v-model="month">
                        <option value="1">فروردین</option>
                        <option value="2">اردیبهشت</option>
                        <option value="3">خرداد</option>
                        <option value="4">تیر</option>
                        <option value="5">مرداد</option>
                        <option value="6">شهریور</option>
                        <option value="7">مهر</option>
                        <option value="8">آبان</option>
                        <option value="9">آذر</option>
                        <option value="10">دی</option>
                        <option value="11">بهمن</option>
                        <option value="12">اسفند</option>
                    </select>
                </div>
                <div class="col-md-3">
                    <label>قرارداد</label>
                    <select class="form-control" v-model="bankname">
                        <option value="iranzamin">ایران زمین</option>
                        <option value="fardabank">فردا بانک</option>
                    </select>
                </div>
            </div>
            <div class="row" style="display: flex; justify-content: end;">
                 <div class="col-md-3" style="margin-top: 29px">
                    <button class="btn btn-primary btn-block" @click="submit" :disabled="!year || !month">
                        <i class="si si-magnifier"></i>
                        جستجو
                    </button>
                </div>
            </div>
            <div class="alert alert-info mt-4 mb-0" v-if="!result && isSearched">
                <p class="mb-0">اطلاعاتی یافت نشد</p>
            </div>
            <div class="alert alert-success mt-4 mb-0" v-if="result && isSearched">
                <p class="mb-0">{{ result }}</p>
            </div>
            <div class="row mt-3" v-if="pages.length > 1" style="overflow-x: hidden;">
                <div class="col-12" style="overflow-x: auto;">
                    <ul class="pagination pagination-circled">
                        <li class="page-item" v-if="currentPage > 1">
                            <a class="page-link" href="#" v-on:click="currentPage--"><i class="icon ion-ios-arrow-forward"></i></a>
                        </li>
                        <li :class="currentPage == page ? 'page-item active' : 'page-item'" v-for="page in pages" :key="page">
                            <a class="page-link" href="#" v-on:click="currentPage = page">{{ page }}</a>
                        </li>
                        <li class="page-item" v-if="pages.length != currentPage">
                            <a class="page-link" href="#" v-on:click="currentPage++"><i class="icon ion-ios-arrow-back"></i></a>
                        </li>
                    </ul>
                </div>
            </div>
            <p v-if="rows.length" class="mt-4 mb-0">تعداد کل : {{ count }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CustomerReport',
    data(){
        return {
            showLoading: false,
            isSearched: false,
            rows: [],
            year: '1402',
            month: '1',
            bankname: 'iranzamin',
            pages: [1],
            result: null,
            perPage: 100,
            count: 0
        }
    },
    watch: {
        currentPage(value){
            this.currentPage = value;
            this.getData();
        }
    },
    methods: {
        getData(){
            this.showLoading = true;
            const postedData = {
                p_month: this.month,
                p_year: this.year,
                p_contract: this.bankname
            };
            this.$api.post('Branches/Report/Bill',postedData).then(({data}) => {
                if(data.status){
                    this.result = 'فایل گزارش صورت وضعیت با موفقیت دانلود شد';
                    window.open('https://cardapi.sabinarya.com/' + data.result)
                }
            }).finally(() => {
                this.isSearched = true;
                this.showLoading = false;
            });
        },
        submit(){
            this.getData();
        }
    }
}
</script>